import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { DEFAULT_SERVICES, CONTACT_INFO, scrollToContact } from "../lib/catalog";

const createServiceSchema = (service) => {
  if (!service) return null;

  return {
    "@context": "https://schema.org",
    "@type": "Service",
    name: service.title,
    description: service.description,
    serviceType: service.title,
    provider: {
      "@type": "LegalService",
      name: "Helen Parlista, S.H, M.Kn - Notaris & PPAT",
      telephone: "+6289609939045",
      email: "notarishelen234@gmail.com",
      address: {
        "@type": "PostalAddress",
        streetAddress: "Jl. Jenderal Ahmad Yani No.37, RT.1",
        addressLocality: "Lemahabang",
        addressRegion: "Jawa Barat",
        postalCode: "45221",
        addressCountry: "ID",
      },
      areaServed: "Indramayu",
    },
    url: window.location.href,
  };
};

export default function ServicePage() {
  const { slug } = useParams();
  const service = DEFAULT_SERVICES.find((item) => item.slug === slug);

  useEffect(() => {
    if (service) {
      const pageTitle = `${service.title} | Notaris & PPAT Indramayu`;
      const pageDescription = service.description;

      document.title = pageTitle;

      const metaDescription = document.querySelector("meta[name=description]");
      if (metaDescription) {
        metaDescription.setAttribute("content", pageDescription);
      }

      let canonical = document.querySelector("link[rel='canonical']");
      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }
      canonical.setAttribute("href", window.location.origin + window.location.pathname);
    }
  }, [service]);

  if (!service) {
    return (
      <main className="min-h-screen bg-[#F9F8F6] pt-28 px-6 lg:px-12">
        <div className="max-w-4xl mx-auto py-24 text-center">
          <h1 className="text-4xl font-serif text-[#1A2B29] mb-6">Layanan tidak ditemukan</h1>
          <p className="text-base text-[#5C6B69] mb-8">
            Maaf, layanan yang Anda cari tidak tersedia. Silakan kembali ke halaman utama untuk memilih layanan lain.
          </p>
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full bg-[#1A2B29] px-6 py-3 text-sm font-semibold text-white hover:bg-[#343f3d] transition-colors"
          >
            Kembali ke Beranda
          </Link>
        </div>
      </main>
    );
  }

  const structuredData = createServiceSchema(service);

  return (
    <main className="min-h-screen bg-[#F9F8F6] pt-28 px-6 lg:px-12">
      <div className="max-w-6xl mx-auto py-20">
        <div className="mb-12">
          <p className="text-sm uppercase tracking-[0.22em] text-[#C4A661] mb-4">Layanan Khusus</p>
          <h1 className="font-serif text-4xl lg:text-5xl text-[#1A2B29] leading-tight mb-6">
            {service.title}
          </h1>
          <p className="max-w-3xl text-base text-[#5C6B69] leading-relaxed">
            {service.description}
          </p>
        </div>

        <div className="grid gap-10 lg:grid-cols-[1.4fr_0.9fr]">
          <section className="space-y-8">
            <div className="rounded-3xl border border-[#E5E3DC] bg-white p-10 shadow-sm">
              <h2 className="font-serif text-2xl text-[#1A2B29] mb-6">Apa yang termasuk</h2>
              <ul className="space-y-4">
                {service.items.map((item) => (
                  <li key={item} className="text-sm text-[#5C6B69] flex gap-3">
                    <span className="mt-1 inline-flex h-2 w-2 rounded-full bg-[#C4A661]" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-3xl border border-[#E5E3DC] bg-white p-10 shadow-sm">
              <h2 className="font-serif text-2xl text-[#1A2B29] mb-6">Hubungi kami</h2>
              <p className="text-sm text-[#5C6B69] leading-relaxed mb-6">
                Siap bantu proses dokumen Anda. Untuk konsultasi dan penjadwalan, gunakan tombol di bawah.
              </p>
              <button
                type="button"
                onClick={scrollToContact}
                className="inline-flex items-center justify-center rounded-full bg-[#1A2B29] px-6 py-3 text-sm font-semibold text-white hover:bg-[#343f3d] transition-colors"
              >
                Kontak Sekarang
              </button>
            </div>
          </section>

          <aside className="rounded-3xl border border-[#E5E3DC] bg-white p-10 shadow-sm">
            <div className="space-y-6">
              <div>
                <p className="text-xs uppercase tracking-[0.24em] text-[#C4A661] mb-3">Kantor</p>
                {CONTACT_INFO.addressLines.map((line) => (
                  <p key={line} className="text-sm text-[#5C6B69] leading-relaxed">
                    {line}
                  </p>
                ))}
              </div>

              <div>
                <p className="text-xs uppercase tracking-[0.24em] text-[#C4A661] mb-3">Telepon</p>
                <p className="text-sm text-[#5C6B69]">{CONTACT_INFO.whatsappLabel}</p>
              </div>

              <div>
                <p className="text-xs uppercase tracking-[0.24em] text-[#C4A661] mb-3">Email</p>
                <p className="text-sm text-[#5C6B69]">{CONTACT_INFO.email}</p>
              </div>
            </div>
          </aside>
        </div>

        <div className="mt-16 rounded-3xl border border-[#E5E3DC] bg-white p-10 shadow-sm">
          <h2 className="font-serif text-2xl text-[#1A2B29] mb-4">Layanan lain</h2>
          <p className="text-sm text-[#5C6B69] mb-6">
            Pilih layanan lain agar Anda mendapatkan halaman yang lebih spesifik untuk kebutuhan hukum Anda.
          </p>
          <div className="grid sm:grid-cols-2 gap-4">
            {DEFAULT_SERVICES.filter((item) => item.slug !== service.slug).map((item) => (
              <Link
                key={item.slug}
                to={`/layanan/${item.slug}`}
                className="rounded-2xl border border-[#E5E3DC] p-4 text-sm text-[#1A2B29] hover:border-[#C4A661] hover:text-[#C4A661] transition-colors"
              >
                {item.title}
              </Link>
            ))}
          </div>
        </div>
      </div>

      {structuredData && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      )}
    </main>
  );
}
